module.exports = __webpack_public_path__ + "static/media/default-product-icon.5287b487.svg";